import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import { Form } from 'react-bootstrap';

import GLNEditor from 'components/manage_manufacturers/manufacturer_details/GLNEditor';
import GLNSourceEditor from 'components/manage_manufacturers/manufacturer_details/GLNSourceEditor';
import InfluenceStatusEditor from 'components/manage_manufacturers/manufacturer_details/InfluenceStatusEditor';
import SimilarNameEditor from 'components/manage_brands/brand_details/SimilarNameEditor';

const MANUFACTURER_FIELDS = {
  SIMILAR_MANUFACTURERS: 'similar_manufacturers',
  MANUFACTURER_GLNS: 'manufacturer_glns',
  GLN_SOURCE: 'gln_source',
  SYNC_BRANDED_PRODUCTS_ONLY_TO_CD: 'sync_branded_products_only_to_cd',
  IS_PARTNER: 'is_partner',
  UPB_DATA_PROVIDER: 'upb_data_provider',
  REQUIRES_MANUFACTURER_PORTAL: 'requires_manufacturer_portal',
  PRESERVE_PRODUCT_NAME_CASING: 'preserve_product_name_casing',
  INFLUENCE_STATUS: 'influence_status',
};

function EditableProperty({ label, manufacturer, setIsEditing, setUpdatedManufacturer, refetch }) {
  const handleUpdateManufacturer = (property, value) => {
    setUpdatedManufacturer(prevManufacturer => ({
      ...prevManufacturer,
      [property]: value,
    }));
  };

  return label === MANUFACTURER_FIELDS.SIMILAR_MANUFACTURERS ? (
    <SimilarNameEditor
      similarManufacturers={manufacturer[MANUFACTURER_FIELDS.SIMILAR_MANUFACTURERS]}
      setIsEditing={setIsEditing}
      refetch={refetch}
    />
  ) : label === MANUFACTURER_FIELDS.MANUFACTURER_GLNS ? (
    <GLNEditor
      initialGLNs={manufacturer[label] || {}}
      onChange={glnsObject => {
        handleUpdateManufacturer(MANUFACTURER_FIELDS.MANUFACTURER_GLNS, glnsObject);
      }}
      onCancel={() => setIsEditing(false)}
    />
  ) : label === MANUFACTURER_FIELDS.GLN_SOURCE ? (
    <GLNSourceEditor
      value={manufacturer[label]}
      onChange={value => handleUpdateManufacturer(MANUFACTURER_FIELDS.GLN_SOURCE, value)}
    />
  ) : label === MANUFACTURER_FIELDS.INFLUENCE_STATUS ? (
    <InfluenceStatusEditor
      value={manufacturer[label]}
      onChange={value => handleUpdateManufacturer(MANUFACTURER_FIELDS.INFLUENCE_STATUS, value)}
    />
  ) : (
    <Form.Control
      as={label === 'description' ? 'textarea' : 'input'}
      rows={10}
      className={css(styles.form)}
      autoFocus
      defaultValue={manufacturer[label]}
      onChange={event => handleUpdateManufacturer(label, event.target.value)}
      onKeyDown={e => {
        if (e.key === 'Escape') {
          setIsEditing(false);
        }
      }}
    />
  );
}

const styles = StyleSheet.create({
  select: {
    flexGrow: 0.96,
  },
  form: {
    height: 'auto',
    marginRight: '0.6rem',
  },
});

EditableProperty.propTypes = {
  label: PropTypes.string,
  manufacturer: PropTypes.object,
  setIsEditing: PropTypes.func,
  updatedManufacturer: PropTypes.object,
  setUpdatedManufacturer: PropTypes.func,
  refetch: PropTypes.func,
};

export default EditableProperty;
export { MANUFACTURER_FIELDS };
